'use es6';

/**
 * Temporary vendored file for react-dnd-multi-backend@8.0.0
 * - source: https://unpkg.com/react-dnd-multi-backend@8.0.0
 * - docs: https://git.hubteam.com/HubSpot/bender-repackages#alternatives-to-repackaging
 */

/* eslint-disable */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["portal"];
export * from '../dnd-multi-backend@8.0.0';
import i, { useState as l, createContext as D } from 'react';
import { DndProvider as m } from 'react-dnd';
import { MultiBackend as P } from '../dnd-multi-backend@8.0.0';
const u = /*#__PURE__*/D(null);
const g = _ref => {
  let {
      portal: e
    } = _ref,
    t = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [r, o] = l(null);
  return /*#__PURE__*/i.createElement(u.Provider, {
    value: e !== null && e !== undefined ? e : r
  }, /*#__PURE__*/i.createElement(m, Object.assign({
    backend: P
  }, t)), e ? null : /*#__PURE__*/i.createElement('div', {
    ref: o
  }));
};
import w, { useContext as k } from 'react';
import { createPortal as M } from 'react-dom';
import { Preview as C, Context as b } from '../react-dnd-preview@8.0.0';
import { useState as v, useEffect as S, useContext as x } from 'react';
import { DndContext as f } from 'react-dnd';
const p = () => {
  const [e, t] = v(!1);
  const r = x(f);
  return S(() => {
    const o = r.dragDropManager.getBackend();
    const n = {
      backendChanged: s => {
        t(s.previewEnabled());
      }
    };
    return t(o.previewEnabled()), o.previewsList().register(n), () => {
      o.previewsList().unregister(n);
    };
  }, [r, r.dragDropManager]), e;
};
const E = e => {
  const t = p();
  const r = k(u);
  if (!t) return null;
  const o = /*#__PURE__*/w.createElement(C, Object.assign({}, e));
  return r !== null ? /*#__PURE__*/M(o, r) : o;
};
E.Context = b;
import { useDrag as T } from 'react-dnd';
import { useContext as B } from 'react';
import { DndContext as y } from 'react-dnd';
const R = (e, t, r, o) => {
  const n = r.getBackend();
  r.receiveBackend(o);
  const s = t(e);
  return r.receiveBackend(n), s;
};
const a = (e, t) => {
  const r = B(y);
  const o = r.dragDropManager.getBackend();
  if (o === void 0) throw new Error('could not find backend, make sure you are using a <DndProvider />');
  const n = t(e);
  const s = {};
  const d = o.backendsList();
  for (const c of d) s[c.id] = R(e, t, r.dragDropManager, c.instance);
  return [n, s];
};
const pe = e => a(e, T);
import { useDrop as O } from 'react-dnd';
const le = e => a(e, O);
import { usePreview as h } from '../react-dnd-preview@8.0.0';
const Se = () => {
  const e = p();
  const t = h();
  return e ? t : {
    display: !1
  };
};
export { g as DndProvider, E as Preview, b as PreviewContext, pe as useMultiDrag, le as useMultiDrop, Se as usePreview };